// Governance roles resolve from Firestore, so a demotion takes effect
// immediately and the next read from an already-open page is denied.
export function describeReadFailure(error: string) {
  return error.toLowerCase().includes("insufficient permissions")
    ? "Your access to this section has changed. Reload the page."
    : error;
}
